module.exports = __webpack_public_path__ + "img/5b9a3bb.png";